import { FundingOption } from '@varo/graphql-schema-types';

const FUNDING_TYPE_ILLUSTRATION_MAP: Partial<Record<FundingOption, string>> = {
  [FundingOption.DebitCard]: 'DEBIT_CARD_A',
  [FundingOption.CashAppPaypalVenmo]: 'CASHAPP_A',
  [FundingOption.CashDeposit]: 'ECASH_B',
  [FundingOption.BankTransfer]: 'BANK_A',
  [FundingOption.DirectDeposit]: 'CASH_A',
  [FundingOption.ApplePay]: 'APPLE_PAY',
  [FundingOption.MobileCheckDeposit]: 'CHECK_A',
  [FundingOption.GooglePay]: 'GOOGLE_PAY',
};

export const getIllustrationForFunding = (type: FundingOption) => {
  return FUNDING_TYPE_ILLUSTRATION_MAP[type] ?? 'CASH_A';
};
